import { IconAlertTriangle } from '@tabler/icons-react';
import type React from 'react';
import { useCallback } from 'react';
import { deleteFileFormat, type FileFormatApiRow } from '@/api/file-formats';
import { FileFormatConfirmDialog } from './file-format-confirm-dialog';

interface DeleteFileFormatDialogProps {
  open: boolean;
  row: FileFormatApiRow | null;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export const DeleteFileFormatDialog: React.FC<DeleteFileFormatDialogProps> = (props) => {
  const handleConfirm = useCallback((row: FileFormatApiRow) => deleteFileFormat(row.id), []);

  return (
    <FileFormatConfirmDialog
      {...props}
      onConfirm={handleConfirm}
      icon={<IconAlertTriangle className="h-5 w-5 text-destructive" />}
      title="Delete file format?"
      description={(code, scopeLabel) => (
        <>
          <p>
            This will soft-delete <strong>{code}</strong> ({scopeLabel}).
          </p>
          <p>
            The format will be hidden from the default list. You can restore it at any time by
            switching to the &apos;Deleted&apos; status filter and clicking Restore.
          </p>
        </>
      )}
      confirmLabel="Delete"
      loadingLabel="Deleting..."
      confirmVariant="destructive"
    />
  );
};
